import { JobRole } from '../types/Employee/JobRole'
import { getAll } from './CommonServices/httpService'

const getRoles = async (): Promise<JobRole[]> => {
	const result = await getAll<JobRole[]>('/Roles')
	return result.data
}

export { getRoles }
